type Metric = {
  name: string;
  value: number;
  delta: number;
  id: string;
};

type WebVitalsModule = {
  getCLS?: (onReport: (metric: Metric) => void) => void;
  getFCP?: (onReport: (metric: Metric) => void) => void;
  getLCP?: (onReport: (metric: Metric) => void) => void;
  getTTFB?: (onReport: (metric: Metric) => void) => void;
  onCLS?: (onReport: (metric: Metric) => void) => void;
  onFCP?: (onReport: (metric: Metric) => void) => void;
  onLCP?: (onReport: (metric: Metric) => void) => void;
  onTTFB?: (onReport: (metric: Metric) => void) => void;
};

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((webVitals: WebVitalsModule) => {
      const reportCLS = webVitals.onCLS ?? webVitals.getCLS;
      const reportFCP = webVitals.onFCP ?? webVitals.getFCP;
      const reportLCP = webVitals.onLCP ?? webVitals.getLCP;
      const reportTTFB = webVitals.onTTFB ?? webVitals.getTTFB;

      reportCLS?.(onPerfEntry);
      reportFCP?.(onPerfEntry);
      reportLCP?.(onPerfEntry);
      reportTTFB?.(onPerfEntry);
    });
  }
};

export default reportWebVitals;
